module.exports = __webpack_public_path__ + "img/apt-2@3x.8d09eb74.jpg";